import { httpService } from '@/services/HttpService';

class NewDedicatedMachineService {
  getNewDedicatedMachineData(workspaceId: number, regionId: number) {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dm/products`);
  }
  getSelectedDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineId: number) {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dm/products/${dedicatedMachineId}`);
  }
  getOperatingSystems(workspaceId: number, regionId: number) {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/dm/operating_systems`);
  }
  reserveDedicatedMachine(workspaceId: number, regionId: number, dedicatedMachineData: any) {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/dm/reservations`, dedicatedMachineData);
  }
}

export const newDedicatedMachineService = new NewDedicatedMachineService();
